import { useCallback } from 'react';
import { AIAgent, AIAgentInputFieldType } from '@nx-frontend/shared/types';
import { isFileAllowed } from './is-file-allowed';

interface UseGetInvalidFieldsParams {
  agent?: AIAgent;
  input: Record<string, string | File>;
}

export const useGetInvalidFields = ({ agent, input }: UseGetInvalidFieldsParams) => {
  const getInvalidFields: () => { id: string; error: string }[] = useCallback(() => {
    const requiredFields = agent?.inputs.filter((agentInput) => agentInput.required) ?? [];
    const agentTextInputs = requiredFields.filter((agentInput) => agentInput.type === AIAgentInputFieldType.TEXT);
    const agentFileInputs = requiredFields.filter((agentInput) => agentInput.type === AIAgentInputFieldType.FILE);

    const emptyFileIds = agentFileInputs
      .filter((agentInput) => !input[agentInput.id] || !(input[agentInput.id] instanceof File))
      .map((input) => input.id);

    const unsupportedFileIds = agentFileInputs
      .filter((agentInput) => !emptyFileIds.includes(agentInput.id))
      .filter((agentInput) => {
        const file = input[agentInput.id] as File;
        return !isFileAllowed(file);
      })
      .map((input) => input.id);

    return [
      ...(agentTextInputs ?? [])
        .filter((agentInput) => !input[agentInput.id])
        .map((input) => ({
          id: input.id,
          error: 'This field is required',
        })),
      ...emptyFileIds.map((id) => ({
        id,
        error: 'This field is required',
      })),
      ...unsupportedFileIds.map((id) => ({
        id,
        error: 'Unsupported file type',
      })),
    ];
  }, [agent?.inputs, input]);

  return getInvalidFields;
};
